import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Task } from '../types';
import { useTask } from "../context/TaskContext";

import './Modal.css';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete?: () => void;
  onModify?: (task: Task | null) => void;
  children: React.ReactNode;
  title?: string;
}

const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, title, onDelete, onModify }) => {
  const { selectedTask } = useTask();

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modalRoot = document.getElementById('modal-root');
  if (!modalRoot) return null;

  return createPortal(
    <div 
      className="modal-overlay" 
      onClick={onClose} 
      onWheel={(e) => e.preventDefault()}
      onTouchMove={(e) => e.preventDefault()}
      style={{ 
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        touchAction: 'none',
        overscrollBehavior: 'none'
      }}
    >
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()} 
        onWheel={(e) => e.stopPropagation()}
        onTouchMove={(e) => e.stopPropagation()}
        style={{ 
          maxHeight: '90vh',
          overflow: 'auto',
          backgroundColor: 'white',
          borderRadius: '4px',
          width: '90%',
          position: 'relative',
          overscrollBehavior: 'contain',
          WebkitOverflowScrolling: 'touch'
        }}
      >
        <div className="modal-header">
          {title &&
            <h3>
              {title}
              <span className="modal-actions">

                {onDelete && selectedTask && !selectedTask.datetimePublished && (
                  <button className="modal-close" onClick={onDelete}>
                    <i className="fas fa-trash-alt"></i>
                  </button>
                )}
                {onModify && selectedTask && !selectedTask.datetimePublished && (
                  <button className="modal-close" onClick={() => onModify?.(selectedTask)}>
                    <i className="fas fa-edit"></i>
                  </button>
                )}

              </span>
            </h3>
          }


          <button className="modal-close" onClick={onClose}>✖</button>
        </div>
        <div className="modal-body">
          <pre style={{ width: '100%' }}>{children}</pre>
        </div>
      </div>
    </div>,
    modalRoot
  );
};

export default Modal;
